export default {
  route: {
    dashboard: 'Dashboard',
    manage: 'manage',
    users: 'users',
    menus: 'menus',
    permissions: 'permissions',
    logs: 'logs',
    example: 'example',
    table: 'table',

    list: 'list',
    tableList: 'table list',
    basicList: 'basic list',
    cardList: 'card list',

    form: 'form',
    basicForm: 'basic form',
    stepForm: 'step form',
    advancedList: 'advanced form',
    step: 'step',

    details: 'details',
    BasicsDetails: 'Basic details page',
    seniorDetails: 'Advanced details page',
    
    enterprise: 'enterprise'
  },
  navbar: {
    search: 'search',
    logOut: 'Log Out',
    dashboard: 'Dashboard',
    github: 'Github',
    screenfull: 'screenfull',
    theme: 'theme',
    lang: 'i18n',
    error: 'error log'
  },
  login: {
    title: 'login',
    logIn: 'Log in',
    username: 'Username',
    password: 'Password',
    any: 'any',
    thirdparty: 'Third',
    thirdpartyTips: 'Can not be simulated on local, so please combine you own business simulation! ! !'
  },
  tagsView: {
    close: 'Close',
    closeOthers: 'Close Others',
    closeAll: 'Close All'
  },
  table: {
    title: 'Title',
    search: 'Search',
    add: 'add',
    addUser: 'addUser',
    id: 'ID',
    email: 'Email',
    phone: 'Phone',
    username: 'User',
    source: 'Source',
    role: 'role',
    account: 'account',
    creatdate: 'Date of creation',
    remarks: 'Remarks',
    state: 'state',
    prohibit: 'Prohibit',
    permissionNew: 'permissionNew',
    permissionUser: 'Permission',
    imdsAi: 'Advanced interface authorization',
    avatar: 'Avatar',
    introduction: 'Introduction',
    paddword: 'paddWord',
    confirmPaddword: 'confirmPaddword',
    powerCode: 'Permission code',
    powerTitle: 'Permission title',
    actions: 'Actions',
    edit: 'Edit',
    delete: 'Delete',
    cancel: 'Cancel',
    confirm: 'Confirm',
    operationType: 'operationType',
    operationDate: 'operationDate',
    date: 'Date',
    operator: 'operator',
    results: 'results of enforcement',
    describe: 'Pedagogical operation',
    preserve: 'preserve',
    signOut: 'sign out'
  }
}
